(function($, Drupal){
  Drupal.behaviors.cflungviewerBehavior = {
    attach : function(context, settings){
      $('body').once("cflungviewerBehavior").each(function(){
        if ($('.hidden-content-display-container').length > 0) {
          $('.bg-img-page').addClass('page-spacing');
        }
        $('.paragraph--type--hww-linked-tile-wrapper').attr('id', 'stayto');
        $('.paragraph--type--hww-linked-tile-wrapper').on('click', function(){
          window.location.hash = "stayto";
        });
        var distance = $('body').offset().top;
        $(window).on('resize scroll', function(){
          if (!$(this).scrollTop() > distance) {
            window.location.hash = ''
          }
        });

        function isMobile(){
          var windowWidth = window.outerWidth;
          if (windowWidth === 0) {
            windowWidth = window.innerWidth;
          }
          if (windowWidth < 769) {
            return true;
          } else {
            return false;
          }
        }

        // A function where the position of logout button is calculated based on
        // the information provided in hero-section
        /*
        function logoutButtonPosition() {
          let heroTextOffset, heroTextHeight;
          let bodyPadding = $('body').css('padding-top') ? $('body').css('padding-top') : 0;
          if ($('.hero-text').length > 0) {
            heroTextOffset = $('.hero-text').offset().top;
            heroTextHeight = $('.hero-text').height();
          }
          else {
            heroTextOffset = $('.field--name-field-hww-body').offset().top;
            heroTextHeight = $('.field--name-field-hww-body').height();
          }
          return heroTextOffset + heroTextHeight - parseInt(bodyPadding) - 10;
        }

        $(window).on("load", function () {
          if (isMobile() && $('#block-docchecklogoutblock').length > 0) {
            $('#block-docchecklogoutblock').css({top: logoutButtonPosition() + 'px'})
          }
        });
         */
        /**
         * Back to top functionality.
         */
        var btn = $("#back-to-top-btn");
        var footertotop = ($('.footer').position().top);
        var scrolltop = $(document).scrollTop() + window.innerHeight;
        var difference = scrolltop - footertotop;
        $(window).scroll(function(){
          if (scrolltop > footertotop) {
            btn.css({ 'bottom' : difference + 50 });
          }
          if ($('body').hasClass("page-ruckblick") && $('#event-code-area-modal').css('display') !== "none") {
            if ($(window).scrollTop() > 300) {
              btn.addClass('show-btn');
            } else {
              btn.removeClass('show-btn');
            }
          } else {
            if ($(window).scrollTop() > document.body.offsetHeight * 0.5) {
              btn.addClass('show-btn');
            } else {
              btn.removeClass('show-btn');
            }
          }
        });
        btn.on('click', function(){
          $('html, body').animate({ scrollTop : 0 }, '300');
        });
        $("button[id^='tab-hidden-content']").attr('id', function(i){
          return "tab-hidden-content" + ++i;
        });
        $(".single-tab").attr('id', function(i){
          return "tab-content" + ++i;
        });
        let hideTab = $('.field--item .paragraph--type--hww-hcdu-item');
        $('#tab-hidden-content1').addClass('active-tab');
        let backgroundImage = '';
        backgroundImage = $('.tab-title:first-child').data('background');
        if ($('.active-tab').length) {
          backgroundImage = $('.active-tab').data('background');
        }
        if ($('.event-agenda-wrapper').length) {
          $('.event-agenda-wrapper').css('background-image', 'url("' + backgroundImage + '")');
        }
        if ($('.bg-img-page').length) {
          if (!isMobile()) {
            $('.bg-img-page').css('background-image', 'url("' + backgroundImage + '")');
          }
        }
        // if ($('.main-hidden-display').length > 0 && !isMobile()) {
        //   $('.main-hidden-display').prepend('<div class="custom-tabs"></div>');
        //   $('.field--name-field-hww-hcdu-items .field--item').each(function () {
        //     $(this).find('.tab-title').appendTo('.custom-tabs');
        //   })
        // }
        if (!hideTab.find('.single-tab').hasClass('tab-visible')) {
          hideTab.find('.single-tab').removeClass('tab-visible');
          hideTab.eq(0).find('.single-tab').addClass('tab-visible');
          hideTab.eq(0).find('.tab-title').addClass('active-tab');
        }
        var tabTitle = $('.tab-title'), tabID;
        tabTitle.on('click', function(){
          if (!$(this).hasClass('linked-tab')) {
            if ($('.event-agenda-wrapper').length) {
              $('.event-agenda-wrapper').css('background-image', 'url("' + $(this).data('background') + '")');
            }
            if ($('.bg-img-page').length) {
              if (!isMobile()) {
                $('.bg-img-page').css('background-image', 'url("' + $(this).data('background') + '")');
              }
            }
            if ($(this).hasClass('active-tab')) {
              $(tabTitle).removeClass('active-tab');
              $('.single-tab').removeClass("tab-visible");
            } else {
              $(tabTitle).removeClass('active-tab');
              $('.single-tab').removeClass("tab-visible");
              $(this).addClass("active-tab");
              tabID = $(this).attr('id').slice(-1);
              $("#tab-content" + tabID).addClass("tab-visible");
            }
          }
        });
        $(window).on("load", function(){
          if ($('.block-hww-event-code-area').length > 0 && $(window).width() < 768) {
            var active_element = $('.block-hww-event-code-area a.active').parent();
            $('.field--name-field-components > .field--items > .field--item:last').insertAfter(active_element);
          }
          if ($('.paragraph--type--hww-hidden-content-display').length > 0) {
            if (isMobile()) {
              $('html, body').animate({ scrollTop : $('.paragraph--type--hww-hidden-content-display').offset().top - 20 }, 500);
            } else {
              $('html, body').animate({ scrollTop : $('.paragraph--type--hww-hidden-content-display').offset().top - 80 }, 500);
            }
          }
        });
        $('.paragraph--type--hww-accordion-item').each(function(){
          $(this).on('click', '.field--name-field-hww-ai-title', function(e){
            if ($(this).parent().hasClass('active-box')) {
              $(this).parent().removeClass('active-box');
            } else {
              $(this).parent().addClass('active-box');
            }
            e.stopPropagation()
          })
        });

        function setMaxHeight(){
          var maxHeight = 0;
          $(".tab-title").each(function(){
            if (maxHeight < $(this).outerHeight()) {
              maxHeight = $(this).outerHeight();
            }
          });
          if (isMobile()) {
            if (maxHeight < 40) {
              maxHeight = 40;
            }
          } else {
            if (maxHeight < 60) {
              maxHeight = 60;
            }
          }
          if (maxHeight !== 0) {
            $(".tab-title .field--name-field-hww-headline").css("min-height", maxHeight);
          }
        }

        setMaxHeight();
        $(window).on("resize load", function(){
          setMaxHeight();
        });
        $(document).on("click", function(e){
          if ($(e.target).is(".field--name-field-hww-headline") === true) {
            $('.paragraph--type--hww-accordion-item').removeClass("active-box");
          }
        });
        $(document).ajaxComplete(function(){
          $('.checkbox').each(function(){
            if ($(this).find('input').is(':checked')) {
              $(this).addClass('input-checked')
            }
          })
          if ($('.pre-item-key').length === 0) {
            $('.views-field-field-hww-tp-content .field--name-field-hww-at-keywords').prepend('<div class="pre-item-key"><p>Keywords:&nbsp;</p></div>');
          }
        });
        if ($('.tab-title').eq(0).hasClass('blocked')) {
          $('.tab-title').eq(0).next('.tab-title').addClass('active-tab');
          $('.tab-title').eq(0).removeClass('active-tab');
          $('.tab-title').eq(0).next('.tab-title').trigger('click');
        }
        $('.professor-wrapper .quote p').each(function(){
          var $this = $(this);
          if ($this.html().replace(/\s|&nbsp;/g, '').length == 0) {
            $this.remove();
          }
        });


        //navbar toggle on click
        $('.navbar-toggle').on("click", function(e){
          if (!$('.navbar-collapse').hasClass('in')) {
            $("header").addClass('navbar-open');
            if ($(".region-navigation .doccheck-logout.logoutorder").length > 0) {
              $('.mosaic-logout').clone().appendTo('.navbar-collapse .header-menu');
              $('.doccheck-logout').clone().appendTo('.navbar-collapse .header-menu');
            } else if ($(".region-navigation .mosaic-logout.logoutorder").length > 0) {
              $('.doccheck-logout').clone().appendTo('.navbar-collapse .header-menu');
              $('.mosaic-logout').clone().appendTo('.navbar-collapse .header-menu');
            }
            $('.navbar-collapse .header-menu .doccheck-logout,.navbar-collapse .header-menu  .mosaic-logout').show();
            setTimeout(function(){
              $('#toolbar-administration').hide()
              $('.navbar-open').css('position', 'fixed');
            }, 400);
            $('body').addClass('locked');
          } else {
            $("header").removeClass('navbar-open');
            $('.navbar-collapse .header-menu .doccheck-logout').remove();
            $('.navbar-collapse .header-menu .mosaic-logout').remove();
            $('#toolbar-administration').show();
            $('.navbar-default').css('position', 'relative');
            $('body').removeClass('locked');
            // $('.region-navigation .block-doccheck-logout-block').show()
          }
          $('.main-container,footer').toggle();
        });
        $(document).on("scroll touchmove mousewheel", function(e){
          if ($('.navbar-collapse').hasClass('in')) {
            e.preventDefault();
          }
        });
        if ($('.image-gallery-wrapper:eq(1) .slide-item').length < 4) {
          $('.image-gallery-wrapper:eq(1) .slick-dots').hide();
        } else {
          $('.image-gallery-wrapper:eq(1) .slick-dots').show();
        }
        // Scroll to section.
        if (window.location.hash) {
          var hashValue = window.location.hash;
          if ($(".tab-title").length > 0) {
            $(".tab-title").removeClass('active-tab');
          }
          if ($(hashValue).length > 0) {
            var index = $(hashValue).parent().index() + 1;
            if ($("#tab-hidden-content" + index).length > 0) {
              $(".single-tab").removeClass('tab-visible');
              $("#tab-hidden-content" + index).addClass('active-tab');
              if ($(window).width() > 1024) {
                $(hashValue).find('button.tab-title').addClass('active-tab');
                $("#tab-content" + index).addClass('tab-visible');
              } else {
                $("#tab-content" + index).addClass('tab-visible');
              }
            }
          }
        }
        if (isMobile()) {
          // Add margin top for slider title, if top title is not present
          $('.paragraph--type--hww-hero-carousel .paragraph--type--hww-hero-title-img').each(function(){
            if ($(this).find('.field--name-field-hww-body').children('.hero-toptitle').length == 0) {
              $(this).find('.field--name-field-hww-body').css({ 'margin-top' : '30px' });
            }
          })
        }
        if ($('.hww-hidden-content-display-all').length) {
          $('.hww-hidden-content-display-all').each(function(){
            var fieldItemCount = $(this).find('.field--name-field-hww-hcdu-items').children('.field--item').length;
            if (fieldItemCount > 4) {
              $(this).addClass('hww-hidden-content-items-count-' + fieldItemCount);
            }
          });
        }

        function toggleShowMore(){
          var i = 0;
          $('.show-more-button').on('click', function(e){
            $(this).parent('.content-block').find('.hide-content').toggleClass('active');
            if ($(this).parent('.content-block').find('.hide-content').hasClass('active')) {
              $(this).html('weniger anzeigen');
            } else {
              $(this).html('mehr erfahren');
            }
          });
        }

        toggleShowMore();
      })
    },
  };

  $(document).ready(function(){

    if ($('body').hasClass('doccheck-required') && !($('body').is('.page-kontakt') || $('body').is('.page-cf-homepage')|| $('body').is('.page-impressum')) ) {
      $('.bg-img-page-no-bg').addClass('d-none');
      $('.bg-img-page').addClass('d-none');
      $('.doccheck-info').removeClass('d-none');
    } else {
      $('.doccheck-info').addClass('d-none');
    }

    if ($('body').hasClass('doccheck-required')) {
      $('#block-cflungviewer-docchecklogoutblock').addClass('d-none');
    } else {
      $('#block-cflungviewer-docchecklogoutblock').removeClass('d-none');
    }

    if ($('body').hasClass('doccheck-required')) {
      var siteURL = "http://" + top.location.host.toString();
      var links = [];

      $('header').find("a[href^='" + siteURL + "'], a[href^='/'], a[href^='./'], a[href^='../'], a[href^='#'], a[href='#doccheck'], a[href='']").not("a[href='/'], a[href='/startseite'], a[href='/kontakt']").each(function(){
        links.push(this);
      });

      $('.region-content').find("a[href^='" + siteURL + "'], a[href^='/'], a[href^='./'], a[href^='../'], a[href^='#'], a[href='#doccheck'], a[href='']").not("a[href='/'], a[href='/startseite'], a[href='/kontakt']").each(function(){
        links.push(this);
      });

      $('#navbar-collapse').find("a[href^='" + siteURL + "'], a[href^='/'], a[href^='./'], a[href^='../'], a[href^='#'], a[href='#doccheck'], a[href='']").not("a[href='/'], a[href='/startseite'], a[href='/kontakt']").each(function(){
        links.push(this);
      });

      $('footer').find("a[href='/fachinformation']").each(function(){
        links.push(this);
      });

      console.log(links);

      if (links.length > 0) {
        $.each(links, function(index, link){
          $(link).click(function(e){
            e.preventDefault();

            var returnURL = $(this).attr('href');

            if ($('body').hasClass('show-mobile-navigation')) {
              $('body').removeClass('show-mobile-navigation');
            }

              $('#modal-doccheck')
                .on('show.bs.modal', function(event){
                  stopBodyScrolling(true);

                  if (returnURL != '') {
                    var iframeURL = docCheckFrameSrc + '/vertex_redirect=' + encodeURIComponent(btoa(returnURL)) + '/';
                    $docCheckFrame.prop('src', iframeURL);
                  }

                })
                .on('hide.bs.modal', function(event){
                  stopBodyScrolling(false);
                })
                .modal('show');
          });
        });
      }
    }

    function stopBodyScrolling(bool){
      if (bool === true) {
        document.ontouchmove = function(e){
          e.preventDefault();
        }
      } else {
        document.ontouchmove = function(e){
          return true;
        }
      }
    }

    var docCheckResizeTimeout;
    var docCheckId = null;
    var host = location.hostname;
    var session_id = location.search.split('session_id=')[1];
    console.log(host);
    switch (host) {
      case 'localhost':
        docCheckId = 2000000019620;
        break;
      case 'cflungviewer-vertex-kunden.digitalspital.de':
        docCheckId = 2000000019622;
        break;
      case 'cf-lungviewer.de':
      case 'www.cf-lungviewer.de':
        docCheckId = 2000000019623;
        break;
    }

    var $docCheckFrame = $('#dc_login_iframe');
    var currentWidth;
    var docCheckFrameSrc = '';

    function updateDocCheckFrameSize(windowWidth){
      var docCheckFrameSize = 'm_red';

      if (currentWidth == $(window).width()) {
        return;
      }
      currentWidth = $(window).width();

      if (windowWidth > 1300) {
        docCheckFrameSize = 'xl_red';
      } else if (windowWidth >= 992) {
        docCheckFrameSize = 'l_red';
      } else if (windowWidth >= 768) {
        docCheckFrameSize = 'm_red';
      } else if (windowWidth > 576) {
        docCheckFrameSize = 'l_red';
      }

      docCheckFrameSrc = 'https://login.doccheck.com/code/de/' + docCheckId + '/' + docCheckFrameSize + '/session_id=QUPxJXh6Ky1wVysbZ1iM50X4DVq4B2JCMgKl4VidBsc';

      $docCheckFrame.prop(
        'src',
        docCheckFrameSrc);
    }

    $(window).resize(function(){
      window.clearTimeout(docCheckResizeTimeout);
      docCheckResizeTimeout = window.setTimeout(function(){
        if ($docCheckFrame.length) {
          updateDocCheckFrameSize($(window).width());
        }
      }, 100);
    });

    $(window).trigger('resize');

    if ($('body').hasClass("doccheck-required")) {
      $('#block-cflungviewer-docchecklogoutblock').addClass('hide');
    } else {
      $('#block-cflungviewer-docchecklogoutblock').addClass('show');
    }

    $('.mobile-menu .navbar-nav .menu-item--expanded .dropdown-toggle').on('click', function() {
      $(this).find('.dropdown-menu').toggleClass('active');
    });

  });

})(jQuery, Drupal);
